import { __read, __spread } from "tslib";
import * as React from 'react';
import { objectIs } from './utils';
var defaultEquality = objectIs;
export function useMappedState(stateGetters, mapperFn, equalityFnOrDeps, mayBeDeps) {
    if (mayBeDeps === void 0) { mayBeDeps = []; }
    var parseArgs = function () {
        if (equalityFnOrDeps === undefined) {
            return [[], defaultEquality];
        }
        if (Array.isArray(equalityFnOrDeps)) {
            return [equalityFnOrDeps, defaultEquality];
        }
        return [mayBeDeps, equalityFnOrDeps];
    };
    var _a = __read(parseArgs(), 2), deps = _a[0], equalityFn = _a[1];
    var mapperCached = React.useCallback(mapperFn, deps);
    var _b = __read(React.useReducer(function (x) { return x + 1; }, 0), 2), forceUpdate = _b[1];
    var stores = React.useMemo(function () {
        return stateGetters.map(function (getter) {
            if (!getter._store) {
                throw new Error("_store not found in getter for module \"" + (getter._module ||
                    'unknown') + "\". Make sure to load the module before using 'useState' or 'useMappedState'.");
            }
            return getter._store;
        });
    }, []);
    var getMappedState = function () {
        var states = stores.map(function (store) { return store.state; });
        return mapperCached.apply(void 0, __spread(states));
    };
    var getSubscribeFn = function () {
        var newState = getMappedState();
        if (!equalityFn(newState, stateRef.current)) {
            stateRef.current = newState;
            forceUpdate({});
        }
    };
    var stateRef = React.useRef(getMappedState());
    var subscribeRef = React.useRef(getSubscribeFn);
    React.useLayoutEffect(function () {
        var subscriptions = stores.map(function (store) {
            return store.subscribe(function () { return subscribeRef.current(); });
        });
        return function () {
            subscriptions.forEach(function (subscription) { return subscription(); });
        };
    }, []);
    React.useMemo(function () {
        stateRef.current = getMappedState();
        subscribeRef.current = getSubscribeFn;
    }, deps);
    return stateRef.current;
}
//# sourceMappingURL=useMappedState.js.map